import { QueryKeysEnum } from '@/enums';
import {
  CreateFmtProduct,
  FmtProductEntity,
  FmtProductParams,
  UpdateFmtProduct,
} from '@/types';
import { BaseService } from './base.service';
import APIService from './axios.service';

class FmtProductService extends BaseService<
  'fmtProduct',
  FmtProductEntity,
  CreateFmtProduct
> {
  constructor() {
    super(QueryKeysEnum.FMT_PRODUCT);
  }

  getAllFmtProducts = (
    payload: FmtProductParams,
  ): Promise<FmtProductEntity[]> => {
    const params: FmtProductParams = { ...payload, isFetchAll: true };
    return APIService.get(this.path, { params });
  };

  updateFmtProduct = (payload: {
    id: string;
    data: UpdateFmtProduct;
  }): Promise<FmtProductEntity> => {
    const { id, data } = payload;
    return APIService.patch(this.path + '/' + id, data);
  };
}

export const fmtProductService = new FmtProductService();
